<template>
	<div class="msg-analysis-link" v-if="!isError">
		<div class="msg-analysis-link-title">
			<p>{{message.link_title}}</p>
		</div>
		<div class="msg-analysis-link-info">
			<p>{{message.link_desc}}</p>
			<img :src="message.link_img"/>
		</div>
		<div class="msg-analysis-link-tip">
			<img src="/img/link-big-8a.png"/>
			<p>普通链接</p>
		</div>
	</div>
	<div class="msg-analysis-link-error" v-else>
		转账消息格式错误，请在手机端查看！
	</div>
</template>

<script>
	import AppConfig from '../../../config/AppConfig.js'
	export default{
		name: 'MsgAnalysisLink',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				message: '',
				isError: false
			}
		},
		methods:{
			format(){
				try {
					let message = JSON.parse(this.msg.content)
					if(message.link_img === undefined || message.link_img === ""){
						message.link_img = "/img/link-big-8a.png"
					}
					this.message = message
				}catch (e) {
					this.isError = true
				}
			}
		},
		
		created() {
			this.format()
		}
	}
</script>

<style>
	.msg-analysis-link-error{
		background-color: #f19595;
		padding: 8px;
		font-size: 12px;
		border-radius: 2px;
	}
	.msg-analysis-link{
		width: 264px;
		height: auto;
		cursor: pointer;
		background-color: #FFFFFF;
		border: 1px solid #dedede;
		border-radius: 4px;
	}
	.msg-analysis-link .msg-analysis-link-title{
		line-height: 20px;
		max-height: 40px;
		overflow: hidden;
		font-weight: 600;
		word-wrap: break-word;
		text-overflow: ellipsis;
		padding: 5px 5px 0 5px;
	}
	.msg-analysis-link .msg-analysis-link-info{
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;
		align-items: center;
		padding: 0 5px;
	}
	.msg-analysis-link-info p{
		flex-grow: 1;
		width: 0;
		max-height: 60px;
		overflow: hidden;
		font-size: 12px;
		color: #a6a6a6;
	}
	.msg-analysis-link-info img{
		width: 40px;
		height: 40px;
		margin-left: 10px;
	}
	.msg-analysis-link .msg-analysis-link-tip{
		display: flex;
		justify-content: flex-start;
		flex-wrap: nowrap;
		align-items: center;
		border-top: 1px solid #dedede;
		padding: 2px 5px;
	}
	.msg-analysis-link-tip img{
		height: 16px;
		width: auto;
		margin-right: 5px;
	}
	.msg-analysis-link-tip p{
		color: #999999;
		font-size: 12px;
		line-height: 20px;
	}
</style>
